// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";
// normalize CSS across browsers
import "./src/styles/normalize.css";
// custom CSS styles
import "./src/styles/style.css";

// Highlighting for code blocks
import "./src/styles/prism.css";

import mediumZoom from "@voderl/medium-zoom";

const options = {
  margin: 24,
  background: "#fff",
  scrollOffset: 40,
  container: undefined,
  template: undefined,
  zIndex: 999,
  excludedSelector: undefined,
  respectSrcsetImageSize: true,
};

export const onClientEntry = () => {
  const { zIndex } = options;

  const styles = `
    .medium-zoom-overlay, .medium-zoom-image--opened {
      z-index: ${zIndex};
    }
  `;

  const node = document.createElement(`style`);
  node.id = `medium-zoom-styles`;
  node.innerHTML = styles;
  document.head.appendChild(node);

  document.addEventListener(
    "play",
    function (e) {
      var audios = document.getElementsByTagName("audio");
      for (var i = 0, len = audios.length; i < len; i++) {
        if (audios[i] != e.target) {
          audios[i].pause();
        }
      }
    },
    true
  );
};

export const onRouteUpdate = () => {
  mediumZoom(".gatsby-resp-image-image", options);
};
